import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react';
import { GlobalProvider } from './Components/Context/GlobalContext';
import chakraTheme from './theme/chakraTheme';


ReactDOM.render(
  <BrowserRouter>
    <HelmetProvider>
      <ChakraProvider theme={chakraTheme}>
        <GlobalProvider>
          <App />
        </GlobalProvider>
      </ChakraProvider>
    </HelmetProvider>
  </BrowserRouter>,
  document.getElementById('root')
);
